import c from 'classnames';
import React from 'react';
import CoreSymbol from '@wix/da-ds/pkg/Indicators/CoreSymbol';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useSelector } from 'react-redux';
import { getUserGiftState } from './redux/selectors';
import { BiData } from '@wix/da-bi/pkg/events';
import { CHECKOUT_IDS, Url } from '@wix/da-url';
import { useTranslation } from 'react-i18next';
import LlamaIcon from '@wix/da-ds/pkg/Icons/Llama';
import CakeIcon from '@wix/da-ds/pkg/Icons/24x24/Cake';
import PointsIcon from '@wix/da-ds/pkg/Icons/Points';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { initGiftStateSuccess, pushGivePointsModal } from './redux/actions';
import { pushBadgeModal } from '../Modals/redux/actionCreators';
import { UserGiftInitStatus } from './redux/types';
import commonStyles from './common.scss';
export function useGiftCoreMenuItem(user) {
    const { t } = useTranslation();
    const { canBeGivenCore, initStatus } = useSelector((state)=>getUserGiftState(state, user.useridUuid));
    const isLoading = initStatus === UserGiftInitStatus.Loading;
    const coreLabel = canBeGivenCore ? t('gifting.giveCore') : t('gifting.hasCore');
    const giveCoreUrl = Url.giveCoreMembership(user.username);
    return {
        icon: isLoading ? /*#__PURE__*/ React.createElement(LoadingIndicator, null) : /*#__PURE__*/ React.createElement(CoreSymbol, {
            size: IconSize.SMALL
        }),
        iconClassName: c(commonStyles['core-icon'], isLoading && commonStyles['loading-spinner']),
        label: coreLabel,
        biData: BiData({
            evid: 275,
            recipientid: user.useridUuid,
            menu_item_name: coreLabel,
            link_url: giveCoreUrl
        }),
        onClick: ()=>window.location.assign(giveCoreUrl),
        disabled: !canBeGivenCore
    };
}
export function useGiftPointsMenuItem(user) {
    const { t } = useTranslation();
    const dispatchPushGivePointsModal = useAction(pushGivePointsModal);
    const pointsLabel = t('gifting.givePoints');
    return {
        icon: /*#__PURE__*/ React.createElement(PointsIcon, null),
        label: pointsLabel,
        biData: BiData({
            evid: 275,
            recipientid: user.useridUuid,
            menu_item_name: pointsLabel
        }),
        onClick: ()=>{
            dispatchPushGivePointsModal(user.username, pointsLabel);
        }
    };
}
export function useGiftLlamaMenuItem(user) {
    const { t } = useTranslation();
    const { canBeGivenLlama, initStatus } = useSelector((state)=>getUserGiftState(state, user.useridUuid));
    const dispatchPushBadgeModal = useAction(pushBadgeModal);
    const dispatchInitGiftStateSuccess = useAction(initGiftStateSuccess);
    const llamaLabel = canBeGivenLlama ? t('gifting.giveLlamaBadge') : t('gifting.hasGotLlamaBadge');
    const isGiftStateLoading = initStatus === UserGiftInitStatus.Loading;
    return {
        icon: isGiftStateLoading ? /*#__PURE__*/ React.createElement(LoadingIndicator, null) : /*#__PURE__*/ React.createElement(LlamaIcon, null),
        iconClassName: c(isGiftStateLoading && commonStyles['loading-spinner']),
        label: llamaLabel,
        biData: BiData({
            evid: 275,
            recipientid: user.useridUuid,
            menu_item_name: llamaLabel
        }),
        onClick: ()=>{
            dispatchPushBadgeModal(user.username, ()=>dispatchInitGiftStateSuccess(user, {
                    canBeGivenLlama: false
                }));
        },
        disabled: !canBeGivenLlama
    };
}
export function useGiftCakeMenuItem(user) {
    const { t } = useTranslation();
    const { canBeGivenCake, initStatus } = useSelector((state)=>getUserGiftState(state, user.useridUuid));
    const cakeLabel = canBeGivenCake ? t('gifting.giveCakeBadge') : t('gifting.hasGotCakeBadge');
    const isGiftStateLoading = initStatus === UserGiftInitStatus.Loading;
    return {
        icon: isGiftStateLoading ? /*#__PURE__*/ React.createElement(LoadingIndicator, null) : /*#__PURE__*/ React.createElement(CakeIcon, null),
        iconClassName: c(isGiftStateLoading && commonStyles['loading-spinner']),
        label: cakeLabel,
        biData: BiData({
            evid: 275,
            recipientid: user.useridUuid,
            menu_item_name: cakeLabel
        }),
        onClick: ()=>{
            window.location.assign(`${Url.checkoutLink(CHECKOUT_IDS.CAKE)}&foruserid=${user.userId}`);
        },
        disabled: !canBeGivenCake
    };
}
export function useGiftMenuItems(user) {
    const giftCoreItem = useGiftCoreMenuItem(user);
    const giftPointsItem = useGiftPointsMenuItem(user);
    const giftLlamaItem = useGiftLlamaMenuItem(user);
    const giftCakeItem = useGiftCakeMenuItem(user);
    return [
        giftCoreItem,
        giftPointsItem,
        giftLlamaItem,
        giftCakeItem
    ];
}

//# sourceMappingURL=giftMenuItems.js.map